<template>
  <div id="contact">

    <!-- <canvas></canvas> -->
    <main id="main" data-page-id="home">
      <section class="innerpage_header" data-scroll-section="h1">
        <video class="bg_innerpages" autoplay muted loop src="../../../assets/video/services.mp4"></video>
        <div class="innerpage_header_textbox">
          <h1> Contact</h1>
        </div>

        <a class="next_slide" v-on:click="NextSlide()">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
            y="0px" width="60px" height="60px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;"
            xml:space="preserve">

            <defs>
            </defs>
            <path class="st0" d="M60,30C60,13.5,46.5,0,30,0S0,13.5,0,30s13.5,30,30,30S60,46.5,60,30z M29.2,45.6l-15-22
            C14.1,23.4,14,23.2,14,23c0-0.2,0-0.3,0.1-0.5c0.2-0.3,0.5-0.5,0.9-0.5h30c0.4,0,0.7,0.2,0.9,0.5c0.2,0.3,0.2,0.7-0.1,1l-15,22
            C30.6,45.8,30.3,46,30,46S29.4,45.8,29.2,45.6z" />
          </svg>

        </a>
      </section>

      <section class="Department centerRow s2">
        <div class="container">
          <div class="row  items grid_items">
            <div class="col-md-6 col-xs-12 ">
              <div class="Department_item">
                <a href="mailto:Sales@MobilityIntel.com"> 
                  <div class="Department_item__info">
                        <h4>Sales Department </h4>
                        <p>Sales@MobilityIntel.com</p>
                  </div>
                 <div class="Department_item__icon">
                     <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="29.1px"
                      height="27.7px" viewBox="0 0 29.1 27.7" style="enable-background:new 0 0 29.1 27.7;" xml:space="preserve">
                    
                    <defs>
                    </defs>
                    <g>
                      <path  style="fill:#FFFFFF;" d="M25.7,13.8c-0.5,0-1-0.1-1.5-0.1c-3-0.2-6-0.3-9.1-0.5c-2.6-0.1-5.1-0.3-7.7-0.4c-1-0.1-1.9-0.1-2.9-0.2
                        c-0.3,0-0.4-0.1-0.5-0.4C2.8,8.5,1.4,4.7,0,0.9c-0.1-0.3,0-0.4,0.2-0.6c0.6-0.4,1.3-0.4,2-0.1c1.6,0.7,3.3,1.4,4.9,2.1
                        c5.1,2.2,10.1,4.5,15,7c1.9,1,3.8,1.9,5.5,3.1c0.4,0.3,0.8,0.6,1.1,0.9c0.4,0.4,0.4,0.7,0,1.1c-0.5,0.5-1.1,0.9-1.7,1.3
                        c-2.7,1.7-5.6,3.1-8.5,4.5c-5.3,2.5-10.7,4.9-16.1,7.2c-0.7,0.3-1.4,0.4-2.1,0.1c-0.5-0.2-0.5-0.3-0.3-0.8c1.3-3.7,2.7-7.4,4-11.1
                        c0.1-0.4,0.3-0.5,0.7-0.5c2.2-0.1,4.4-0.2,6.6-0.4c2.1-0.1,4.1-0.2,6.2-0.4c2.1-0.1,4.2-0.2,6.3-0.3C24.5,14,25.1,13.9,25.7,13.8
                        C25.7,13.9,25.7,13.8,25.7,13.8z"/>
                    </g>
                    </svg>   
                 </div>

                </a>
              </div>

            </div>
            <div class="col-md-6 col-xs-12 ">
              <div class="Department_item">
                <a href="mailto:Marketing@MobilityIntel.com"> 
                  <div class="Department_item__info">
                        <h4>Marketing & Public Relations </h4>
                        <p>Marketing@MobilityIntel.com</p>
                  </div>
                 <div class="Department_item__icon">
                     <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="29.1px"
                      height="27.7px" viewBox="0 0 29.1 27.7" style="enable-background:new 0 0 29.1 27.7;" xml:space="preserve">
                    
                    <defs>
                    </defs>
                    <g>
                      <path  style="fill:#FFFFFF;" d="M25.7,13.8c-0.5,0-1-0.1-1.5-0.1c-3-0.2-6-0.3-9.1-0.5c-2.6-0.1-5.1-0.3-7.7-0.4c-1-0.1-1.9-0.1-2.9-0.2
                        c-0.3,0-0.4-0.1-0.5-0.4C2.8,8.5,1.4,4.7,0,0.9c-0.1-0.3,0-0.4,0.2-0.6c0.6-0.4,1.3-0.4,2-0.1c1.6,0.7,3.3,1.4,4.9,2.1
                        c5.1,2.2,10.1,4.5,15,7c1.9,1,3.8,1.9,5.5,3.1c0.4,0.3,0.8,0.6,1.1,0.9c0.4,0.4,0.4,0.7,0,1.1c-0.5,0.5-1.1,0.9-1.7,1.3
                        c-2.7,1.7-5.6,3.1-8.5,4.5c-5.3,2.5-10.7,4.9-16.1,7.2c-0.7,0.3-1.4,0.4-2.1,0.1c-0.5-0.2-0.5-0.3-0.3-0.8c1.3-3.7,2.7-7.4,4-11.1
                        c0.1-0.4,0.3-0.5,0.7-0.5c2.2-0.1,4.4-0.2,6.6-0.4c2.1-0.1,4.1-0.2,6.2-0.4c2.1-0.1,4.2-0.2,6.3-0.3C24.5,14,25.1,13.9,25.7,13.8
                        C25.7,13.9,25.7,13.8,25.7,13.8z"/>
                    </g>
                    </svg>   
                 </div>

                </a>
              </div>

            </div>
            <div class="col-md-6 col-xs-12 ">
              <div class="Department_item ">
                <a href="mailto:HR@MobilityIntel.com"> 
                  <div class="Department_item__info">
                        <h4>Career & HR Department </h4>
                        <p>HR@MobilityIntel.com</p>
                  </div>
                 <div class="Department_item__icon">
                     <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="29.1px"
                      height="27.7px" viewBox="0 0 29.1 27.7" style="enable-background:new 0 0 29.1 27.7;" xml:space="preserve">
                    
                    <defs>
                    </defs>
                    <g>
                      <path  style="fill:#FFFFFF;" d="M25.7,13.8c-0.5,0-1-0.1-1.5-0.1c-3-0.2-6-0.3-9.1-0.5c-2.6-0.1-5.1-0.3-7.7-0.4c-1-0.1-1.9-0.1-2.9-0.2
                        c-0.3,0-0.4-0.1-0.5-0.4C2.8,8.5,1.4,4.7,0,0.9c-0.1-0.3,0-0.4,0.2-0.6c0.6-0.4,1.3-0.4,2-0.1c1.6,0.7,3.3,1.4,4.9,2.1
                        c5.1,2.2,10.1,4.5,15,7c1.9,1,3.8,1.9,5.5,3.1c0.4,0.3,0.8,0.6,1.1,0.9c0.4,0.4,0.4,0.7,0,1.1c-0.5,0.5-1.1,0.9-1.7,1.3
                        c-2.7,1.7-5.6,3.1-8.5,4.5c-5.3,2.5-10.7,4.9-16.1,7.2c-0.7,0.3-1.4,0.4-2.1,0.1c-0.5-0.2-0.5-0.3-0.3-0.8c1.3-3.7,2.7-7.4,4-11.1
                        c0.1-0.4,0.3-0.5,0.7-0.5c2.2-0.1,4.4-0.2,6.6-0.4c2.1-0.1,4.1-0.2,6.2-0.4c2.1-0.1,4.2-0.2,6.3-0.3C24.5,14,25.1,13.9,25.7,13.8
                        C25.7,13.9,25.7,13.8,25.7,13.8z"/>
                    </g>
                    </svg>   
                 </div>

                </a>
              </div>

            </div>
           <div class="col-md-6 col-xs-12 ">
              <div class="Department_item">
                <a href="mailto:Finance@Mobilityintel.com"> 
                  <div class="Department_item__info">
                        <h4>Investor Relations </h4>
                        <p>Finance@Mobilityintel.com</p>
                  </div>
                 <div class="Department_item__icon">
                     <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="29.1px"
                      height="27.7px" viewBox="0 0 29.1 27.7" style="enable-background:new 0 0 29.1 27.7;" xml:space="preserve">
                    
                    <defs>
                    </defs>
                    <g>
                      <path  style="fill:#FFFFFF;" d="M25.7,13.8c-0.5,0-1-0.1-1.5-0.1c-3-0.2-6-0.3-9.1-0.5c-2.6-0.1-5.1-0.3-7.7-0.4c-1-0.1-1.9-0.1-2.9-0.2
                        c-0.3,0-0.4-0.1-0.5-0.4C2.8,8.5,1.4,4.7,0,0.9c-0.1-0.3,0-0.4,0.2-0.6c0.6-0.4,1.3-0.4,2-0.1c1.6,0.7,3.3,1.4,4.9,2.1
                        c5.1,2.2,10.1,4.5,15,7c1.9,1,3.8,1.9,5.5,3.1c0.4,0.3,0.8,0.6,1.1,0.9c0.4,0.4,0.4,0.7,0,1.1c-0.5,0.5-1.1,0.9-1.7,1.3
                        c-2.7,1.7-5.6,3.1-8.5,4.5c-5.3,2.5-10.7,4.9-16.1,7.2c-0.7,0.3-1.4,0.4-2.1,0.1c-0.5-0.2-0.5-0.3-0.3-0.8c1.3-3.7,2.7-7.4,4-11.1
                        c0.1-0.4,0.3-0.5,0.7-0.5c2.2-0.1,4.4-0.2,6.6-0.4c2.1-0.1,4.1-0.2,6.2-0.4c2.1-0.1,4.2-0.2,6.3-0.3C24.5,14,25.1,13.9,25.7,13.8
                        C25.7,13.9,25.7,13.8,25.7,13.8z"/>
                    </g>
                    </svg>   
                 </div>

                </a>
              </div>

            </div>
          </div>
        </div>
      </section>

      
      <section class="section-abuse active" style="visibility: visible;">
        <div class="abuse-header__block">
          <div class="container row">
            <div class="text-block center-text">
              <h1 class="md-title title">Contact us</h1>

            </div>

          </div>
        </div>
        <div class="abuse-form__block form__block">
          <div class="container">
          <form action="#" id="abuse-form" novalidate="novalidate" class="custom-form abuse-form" v-if="!this.submitStatus">
              <div class="form__wrap">
                <div class="form-content__wrap">
                  <div class="col-md-6">
                    <div class="row" style="display:none">
                       <div class="input__wrap">
                       <v-select :options="emaildata" 
                        v-model="selectedEmail"
                        placeholder="Reasons for a contact request"

                        ></v-select>
                       </div>
                    </div>
                    <div class="row">
                      <div class="input__wrap">
                        

                        <input type="text" v-model.trim="$v.name.$model" id="abuse.fullName" name="abuse.fullName"
                          required="required" class="required "
                          :class="{ 'error': $v.name.$error,'valid':!$v.name.$invalid }"> <label for="abuse.fullName"
                          class="input-label">Full
                          Name</label>
                        <div class="error-tooltip__wrap">
                          <h4 class="menu-link up-text error-tooltip__content">Invalid Full Name</h4>
                          <p class="description">You can use only English letters, space, comma, apostrophe, dash, and
                            period (,.'-)</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="input__wrap">
                        <input type="email" v-model.trim="$v.email.$model" id="abuse.email" name="abuse.email"
                          required="required" class="required"
                          :class="{ 'error': $v.email.$error,'valid':!$v.email.$invalid }">
                        <label for="abuse.email" class="input-label">Email Address
                          </label>
                        <div class="error-tooltip__wrap">
                          <h4 class="menu-link up-text error-tooltip__content">Invalid email</h4>
                          <p class="description">Please, check that you include an '@' and '.' in the email address</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="input__wrap password__wrap">
                        <input v-model.trim="$v.phone.$model" type="tel" id="abuse.phoneNumber" name="abuse.phoneNumber"
                          required="required" class="required"
                          :class="{ 'error': $v.phone.$error,'valid':!$v.phone.$invalid }"> <label
                          for="abuse.phoneNumber" class="input-label">Phone Number</label>
                        <div class="error-tooltip__wrap">
                          <h4 class="menu-link up-text error-tooltip__content">Invalid Phone Number</h4>
                          <p class="description">You can use only numbers &amp; + (plus) symbol</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box pl-5">
                      <div class="row">
                        <div class="input__wrap password__wrap">
                          <input type="text" v-model="subject" id="abuse.subject" name="abuse.subject"
                            v-model.trim="$v.subject.$model"
                            required="required" class="required"
                            :class="{ 'error': $v.subject.$error,'valid':!$v.subject.$invalid }">
                          <label for="abuse.phoneNumber" class="input-label">Subject</label>
                          <div class="error-tooltip__wrap">
                            <h4 class="menu-link up-text error-tooltip__content">Invalid Phone Number</h4>
                            <p class="description">Please, fill out this field</p>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="input__wrap password__wrap">
                          <input type="text" v-model="company" id="abuse.company" name="abuse.company"
                            required="required" class="required" :class="{valid:(company.length>0)}">
                          <label for="abuse.company" class="input-label">Company Name</label>
                          <div class="error-tooltip__wrap">
                            <h4 class="menu-link up-text error-tooltip__content">Invalid Ccompany</h4>
                            <p class="description">Please, fill out this field</p>
                          </div>
                        </div>
                      </div>
                      <div class="row">

                        <div class="textarea__wrap input__wrap">
                          <textarea name="abuse.detailsAbuse" v-model.trim="$v.message.$model" id="abuse.detailsAbuse"
                            required="required" :class="{ 'error': $v.message.$error,'valid':!$v.message.$invalid }"
                            class="required"></textarea> <label for="abuse.timeOfContact"
                            class="input-label">Message Box</label>
                          <div class="error-tooltip__wrap">
                            <h4 class="menu-link up-text error-tooltip__content">Please, fill out this field</h4>
                            <p class="description xxs-visible">Please, fill out this field</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
              <vue-recaptcha
                ref="recaptcha"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
                @render="onCaptchaRendered"
                size="checkbox"
                theme	="dark"
                :sitekey="this.sitekey">
                </vue-recaptcha>
                </div>
                <div class="button__wrap submit__wrap">
                  <button id="abuse-submit" type="button" @click="submit()"
                    class="button button--white-hover-grad button--submit pulse">Send</button></div>
              </div>
            </form>
            <div v-else>

              <p class="sentsuccesfully">
                sent succesfully
              </p>
            </div>
           
          </div>
        </div>
      </section>





      <section class="started-section">
        <video class="bg_innerpages" autoplay muted loop src="../../../assets/video/services.mp4"></video>

        <div class="container row started__container">
          <div class="content__left">
            <div class="js-content-block text-block">
              <h2 class="title md-title">MI</h2>
              <p class="subtitle">this is where imagination meets innovation.</p>
            </div>
          </div>
          <div class="content__right">
            <div class="buttons__wrap">
              <a href="https://web.mobilityintel.com" class="button button--transparent pulse">get started</a>
            </div>
          </div>
        </div>
      </section>

      <section class="o-eric-progress e-scrol">
        <div class="c-eric-progress-container">
          <div class="c-eric-progress">
            <div class="c-eric-progress__counter">
              <div class="c-eric-progress__counter-zero">0</div>
              <div class="c-eric-progress__counter-item">

              </div>
            </div>
            <div class="c-eric-progress-el">

            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import flexbox from 'flexboxgrid';
  import global from '@/mixins/global';
  import vSelect from 'vue-select';
  import VueRecaptcha from 'vue-recaptcha';


  // import Vuelidate from 'vuelidate';
  import axios from 'axios';
  import {
    required,
    minLength,
    email,
    numeric
  } from 'vuelidate/lib/validators';

  export default {
    name: 'Contact',
    data() {
      return {
        name: '',
        email: '',
        phone: '',
        company: '',
        message: '',
        htmlpage: "",
        subject:"",
        sitekey: "6LeKEokaAAAAANt--Lbr__JFA9Dcmm0ncQ0lEMLc",
        widgetId: '',
        submitStatus:false,
        selectedEmail:[],
        recaptchaStatus:false,
        placeholderItem: '2' ,
        emaildata:[{
                      label:"Interested in MI’s customized solutions",
                      value:"info@mobilityintel.com"
                   },{
                      label:"Providing MI with a service",
                      value:"info@mobilityintel.com,Finance@mobilityintel.com"
                   },{
                      label:"Partnership Inquiry",
                      value:"info@mobilityintel.com,Finance@mobilityintel.com"
                   },{
                      label:"Investor Inquiry",
                      value:"info@mobilityintel.com,Finance@mobilityintel.com"
                   },{
                      label:"Having troubles with our website",
                      value:"Safwat@mobilityintel.com,info@mobilityintel.com"
                   },{
                      label:"Submitting feedback",
                      value:"info@mobilityintel.com"
                   },{
                      label:"Membership Inquiry ",
                      value:"info@mobilityintel.com,Finance@mobilityintel.com"
                   },{
                      label:"Other",
                      value:"info@mobilityintel.com"
                   }
        ]
      };
    },
    validations: {
      name: {
        required,
        minLength: minLength(4)
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        numeric
      },
      message: {
        required,
        minLength: minLength(4)
      },subject: {
        required,
        minLength: minLength(4)
      }

    },

    // components: { Vuelidate },
    mixins: [global],
    beforeMount() {

    },
    computed: {
  getSelectorPlaceholder: function () {
    return this.placeholderItem
  }
  },
    methods: {
      fetchData() {
        
      },
      submit() {
      this.$v.$touch()
      if (this.$v.$invalid || !this.recaptchaStatus ) {
        this.submitStatus = false;
      } else {
        var form = {
          fullName:this.name,
          email:this.email,
          phoneNumber:this.phone,
          message:this.message,
          company:this.company,
          reason: this.emaildata[0].label,
          sendTo: this.emaildata[0].value,
          subject:this.subject
        }

        this.submitStatus = true ; 
          axios.post('https://superapi.mobilityintel.com/api/LandingPage/Contact',form).then(function (response) {
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
        setTimeout(() => {
          this.submitStatus = 'OK'
        }, 500)
      }},
      NextSlide() {
        var val = $("section.s2").offset().top;
        window.scrollTo({
          top: val,
          behavior: 'smooth'
        });
      },
      setToken: function(token) {
                this.form['g-recaptcha-response'] = token;
      },
      onCaptchaVerified: function(token) {
          this.recaptchaStatus = true;
      },
      onCaptchaExpired: function() {
          this.setToken('');
      },
      onCaptchaRendered: function(id) {
          this.widgetId = id;
      },
    },

    created() {},
    components:{vSelect,VueRecaptcha
    },

    mounted() {

      this.fetchData();
    },
     metaInfo: {
      title: 'Contact',
      // titleTemplate: '%s | vue-meta Example App'
    },
  };

</script>
<style lang="scss">
  @import './style.scss';
@import "vue-select/src/scss/vue-select.scss";

.vs__dropdown-toggle {
    border: 1px solid rgb(36,173,96);
    background-color: #1b162f;
    padding: 16px 0;
}
input.vs__search {
    color: #24ad60;
    padding-left: 15px;
    font-weight: 500;
    font-family: 'Roboto';
}

span.vs__selected {
    color: white;
    padding-left: 15px;
    font-weight: 500;
    font-family: 'Roboto';
}

div#vs1__combobox input {
    // color: white;.
     padding-left: 15px;
    font-weight: 500;
    font-family: 'Roboto';
}
button.vs__clear svg path {
    fill: #24ad60;
}

button.vs__clear +svg path {fill: #24ad60;}

div#vs1__combobox {
    padding-right: 17px;
}
iframe.contact_form {
    width: 100%;
    height: 712px;
    overflow: hidden;
    border: 0;
}
@media screen and (max-width:1024px) {
  button#abuse-submit {
    margin-top: 49px;
}
}

@media screen and (max-width:850px) {
iframe.contact_form {
    height: 1212px;
}
.abuse-form__block.form__block .container {
    margin: 0;
    max-width: 100%;
    width: 100%;
    padding: 0;
}
}

</style>



// WEBPACK FOOTER //
// src/components/Contact/index.vue